import { useEffect } from 'react'

import { ObserverSubject } from '@/lib/Observer'
import { WalletContextType } from '@/wallets'

export const WalletObserverSubject = new ObserverSubject<WalletContextType>()

export function useSubscribeWalletConnected(callback: (data: WalletContextType) => void) {
  useEffect(() => {
    const unsubscribe = WalletObserverSubject.subscribe(callback)
    return unsubscribe
  }, [callback])
}
